<template>
  <div class="freight-identification">
    <div class="freight-identification__row">
      <div
        class="freight-identification__field freight-identification__field--codigo"
      >
        <label class="freight-identification__label">
          <span class="freight-identification__required">*</span> Código
        </label>
        <a-input
          :value="codigo"
          size="large"
          placeholder="Ex.: 106"
          @change="onChange('codigo', $event)"
        />
      </div>

      <div
        class="freight-identification__field freight-identification__field--descricao"
      >
        <label class="freight-identification__label">
          <span class="freight-identification__required">*</span> Descrição
        </label>
        <a-input
          :value="descricao"
          size="large"
          placeholder="Ex.: Parceiro L & M"
          @change="onChange('descricao', $event)"
        />
      </div>

      <div
        class="freight-identification__field freight-identification__field--modal"
      >
        <label class="freight-identification__label">Modal</label>
        <a-input :value="modal" size="large" disabled />
      </div>
    </div>

    <div class="freight-identification__field">
      <label class="freight-identification__label"
        >Observação
        <span class="freight-identification__optional">(opcional)</span></label
      >
      <a-textarea
        :value="observacao"
        :maxLength="40"
        :rows="4"
        placeholder="Digite aqui uma descrição para essa tabela"
        @change="onObservacaoChange"
      />
      <div class="freight-identification__counter">
        {{ (observacao || "").length }} / 40
      </div>
    </div>

    <div class="freight-identification__radios">
      <div class="freight-identification__radio-cell">
        <span class="freight-identification__radio-title">Tabela</span>
        <a-radio-group
          class="freight-identification__radio-group"
          :value="tpTabela"
          @change="$emit('update:tpTabela', $event.target.value)"
        >
          <a-radio v-for="opt in tpTabelaOptions" :key="opt.value" :value="opt.value">
            {{ opt.label }}
          </a-radio>
        </a-radio-group>
      </div>

      <div class="freight-identification__radio-cell">
        <span class="freight-identification__radio-title">
          <span class="freight-identification__required">*</span> Tipo
        </span>
        <a-radio-group
          class="freight-identification__radio-group"
          :value="tpReceitaDespesa"
          @change="$emit('update:tpReceitaDespesa', $event.target.value)"
        >
          <a-radio
            v-for="opt in tpReceitaDespesaOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-radio>
        </a-radio-group>
      </div>

      <div class="freight-identification__radio-cell">
        <span class="freight-identification__radio-title">Composição</span>
        <a-radio-group
          class="freight-identification__radio-group"
          :value="tpComposicao"
          @change="$emit('update:tpComposicao', $event.target.value)"
        >
          <a-radio v-for="opt in composicaoOptions" :key="opt.value" :value="opt.value">
            {{ opt.label }}
          </a-radio>
        </a-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FREIGHT_TABLE_COMPOSICAO_SIMPLES,
  MODAL_PADRAO,
  TP_COMPOSICAO_OPTIONS,
  TP_RECEITA_DESPESA_OPTIONS,
  TP_TABELA_OPTIONS,
} from "../../constants/freightTableOptions";

export default {
  name: "FreightTableIdentificationSection",
  props: {
    codigo: { type: String, default: "" },
    descricao: { type: String, default: "" },
    observacao: { type: String, default: "" },
    tpTabela: { type: Number, default: null },
    tpReceitaDespesa: { type: Number, default: null },
    tpComposicao: { type: Number, default: null },
  },
  data() {
    return {
      modal: MODAL_PADRAO,
      tpTabelaOptions: TP_TABELA_OPTIONS,
      tpReceitaDespesaOptions: TP_RECEITA_DESPESA_OPTIONS,
    };
  },
  computed: {
    // Só "Simples": composta e de composição exigem o multiselect de tabelas componentes,
    // que a UI nova não tem. O valor atual entra na lista para uma tabela legada com
    // tp_composicao 2 não abrir sem radio marcado.
    composicaoOptions() {
      return TP_COMPOSICAO_OPTIONS.filter(
        (opt) =>
          opt.value === FREIGHT_TABLE_COMPOSICAO_SIMPLES ||
          opt.value === this.tpComposicao,
      );
    },
  },
  methods: {
    readValue(e) {
      return e && e.target ? e.target.value : e;
    },
    onChange(field, e) {
      this.$emit(`update:${field}`, this.readValue(e));
    },
    onObservacaoChange(e) {
      const value = String(this.readValue(e) || "").slice(0, 40);
      this.$emit("update:observacao", value);
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-identification {
  &__row {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 24px;
  }

  &__field {
    &--codigo {
      flex: 0 0 200px;
    }

    &--descricao {
      flex: 1 1 auto;
      min-width: 0;
    }

    &--modal {
      flex: 0 0 260px;
    }
  }

  &__label {
    display: block;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.88);
  }

  &__required {
    color: @color-error;
  }

  &__optional {
    color: rgba(0, 0, 0, 0.45);
  }

  &__counter {
    text-align: right;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 4px;
  }

  &__radios {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__radio-cell {
    flex: 1 1 200px;
    min-width: 0;
  }

  &__radio-title {
    display: block;
    padding: 4px 8px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
  }

  &__radio-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    /deep/ .ant-radio-wrapper {
      display: inline-flex;
      align-items: center;
      margin-right: 0;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 14px;
      line-height: 22px;
    }

    /deep/ .ant-radio-checked .ant-radio-inner {
      border-color: @color-primary;
      background: @color-primary;

      &::after {
        background: #ffffff;
        transform: scale(0.625);
      }
    }

    /deep/ .ant-radio-checked::after,
    /deep/ .ant-radio:hover .ant-radio-inner,
    /deep/ .ant-radio-input:focus + .ant-radio-inner {
      border-color: @color-primary;
    }
  }

  /deep/ .ant-input {
    border-radius: 8px;
    font-size: 16px;
    line-height: 24px;
  }

  /deep/ .ant-input[disabled] {
    background: rgba(0, 0, 0, 0.04);
  }

  /deep/ textarea.ant-input {
    border-radius: 6px;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>

<style lang="less">
@import "~@/modules/shared/styles/form-controls.less";

.freight-identification {
  .module-form-controls(16px; 16px);
}
</style>
